module.exports = __webpack_public_path__ + "static/media/satellite.bd620cb5.png";